if (!customElements.get('promotion-offer')) {
  class PromotionOffer extends HTMLElement {
    constructor() {
      super();
      this.button = this.querySelector('.promotion-offer__button');
      this.price = this.querySelector('[data-promotion-price]');
      this.copyResetTimer = null;
      this.handleVariantChange = this.handleVariantChange.bind(this);
    }

    connectedCallback() {
      this.button?.addEventListener('click', () => this.copyCode());
      document.addEventListener('product:variant-change', this.handleVariantChange);
    }

    disconnectedCallback() {
      document.removeEventListener('product:variant-change', this.handleVariantChange);
      window.clearTimeout(this.copyResetTimer);
    }

    async copyCode() {
      try {
        await navigator.clipboard.writeText(this.dataset.code);
      } catch (error) {
        const input = document.createElement('textarea');
        input.value = this.dataset.code;
        input.setAttribute('readonly', '');
        input.style.position = 'fixed';
        input.style.opacity = '0';
        document.body.appendChild(input);
        input.select();
        document.execCommand('copy');
        input.remove();
      }

      this.classList.add('is-copied');
      this.querySelector('.promotion-offer__status').textContent = 'Code copied';
      window.clearTimeout(this.copyResetTimer);
      this.copyResetTimer = window.setTimeout(() => {
        this.classList.remove('is-copied');
        this.querySelector('.promotion-offer__status').textContent = 'Click to copy and apply';
      }, 1800);

      const discountApplied = await this.applyDiscount();
      if (discountApplied && this.classList.contains('is-copied')) {
        this.querySelector('.promotion-offer__status').textContent = 'Code copied and applied';
      }
    }

    async applyDiscount() {
      const root = window.Shopify?.routes?.root || '/';
      const discountUrl = `${root}discount/${encodeURIComponent(this.dataset.code)}?redirect=${encodeURIComponent(`${root}cart.js`)}`;

      try {
        const response = await fetch(discountUrl, {
          credentials: 'same-origin',
          headers: { Accept: 'application/json' }
        });
        return response.ok;
      } catch (error) {
        return false;
      }
    }

    handleVariantChange(event) {
      if (!this.hasAttribute('data-update-variant') || !this.price || !this.dataset.percentage || !event.detail.variant) return;

      const multiplier = (100 - Number(this.dataset.percentage)) / 100;
      this.price.textContent = formatMoney(
        Math.round(event.detail.variant.price * multiplier),
        theme.settings.money_with_currency_format
      );
    }
  }

  customElements.define('promotion-offer', PromotionOffer);
}
